import React, { useContext, useEffect, useState } from "react";
import useNetworkStatus from "./NetworkStatusCheck";
import "./CommonErrorMessagePopup.css";
import { AppContext } from "../AppContext";
import background_img from "../assets/background_img.png";
import CustomButton from "./CustomButton.js";
import { Translate } from "./LanguageChanger.js";

let resolution = "FHD";

const CommonErrorMessagePopup = ({
  title = "Uh oh!",
  message = <Translate langKey={'network-unable'}/>,
  buttonText = <Translate langKey={"retry"}/>,
  handlerRetry = undefined,
  onClose,
}) => {
  const { isOnline, networkType } = useNetworkStatus();
  const { errorPopup, setErrorPopup, screen, setLastScreen } =
    useContext(AppContext);
  const [focus, setFocus] = useState({
    isRetrySelected: false,
    isCanceledSelected: false,
  });

  const handleKeyDown = (e) => {
    console.log(`DEBUG keydown event : ${e.keyCode}`);

    if (e.keyCode === 13) {
      retryHandler();
    }
  };

  const retryHandler = () => {
    console.log(`DEBUG default retry : reloading app.`);
    window.appReload();
  };

  useEffect(() => {
    if (
      !isOnline &&
      (errorPopup.show === "unset" || errorPopup.show === "not visible")
    ) {
      setErrorPopup({
        show: "visible",
        type: "NETWORK_ERROR",
      });

      setLastScreen(screen);
    }

    if (isOnline && errorPopup.show === "visible") {
      setErrorPopup({
        show: "not visible",
        type: "NETWORK_ERROR",
      });
    }
  }, [isOnline]);

  return (
    <>
      {errorPopup.show === "visible" && (
        <div
          onKeyDown={handleKeyDown}
          tabIndex={0}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 99999998,
            backdropFilter: "blur(5px)", // Add this line for background blur
            backgroundImage: `url(${background_img})`,
          }}
        >
          <div
            id="floating-popup"
            style={{
              position: "fixed",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "65vh",
              height: "20vh",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#0E1653",
              color: "#fff",
              padding: "50px",
              borderRadius: "8px",
              textAlign: "center",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              zIndex: 99999999,
            }}
          >
            <h3
              style={{
                margin: "0",
                padding: "0",
                fontSize: "3rem",
                boxSizing: "border-box",
              }}
            >
              {title}
            </h3>
            <p
              style={{
                margin: "0",
                padding: "0",
                fontSize: "2rem",
                boxSizing: "border-box",
              }}
            >
              {message}
            </p>
            {/* <p
                style={{
                  margin: "0",
                  marginTop: "2rem",
                  fontStyle: "italic",
                  padding: "0",
                  fontSize: "2rem",
                  boxSizing: "border-box",
                }}
              >
                CODE: {errorPopup.type || "APP_ERROR"}
              </p> */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <button
                style={{
                  marginTop: "2rem",
                  padding: "15px 25px", // Increased padding
                  background: "#EC008C",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  width: "35vh", // Increased width
                  height: "6vh", // Increased height
                  borderRadius: "1rem",
                  fontSize: "2rem",
                  fontWeight: "bold",
                }}
                onClick={retryHandler}
              >
                {buttonText}
              </button>

              {/* <CustomButton
                  // navigateTo="/homepage"
                  fontSize={resolution === "FHD" ? "24px" : "18px"}
                  defaultSelected={true}
                  width={resolution === "FHD" ? "20vw" : "12vw"}
                  height={resolution === "FHD" ? "7vh" : "7vh"}
                  left={resolution === "FHD" ? "-19vw" : "-13vw"}
                  right={resolution === "FHD" ? "-25vw" : "-25vw"}
                  onClick={retryHandler}
                  onKeyDown={handleKeyDown}
                >
                  Retry
                </CustomButton> */}

              {/* <button
                  style={{
                    marginTop: "2rem",
                    marginLeft: "1rem",
                    padding: "15px 25px", // Increased padding
                    background: "#555",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    width: "35vh", // Increased width
                    height: "6vh", // Increased height
                    borderRadius: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                  onClick={onClose}
                >
                  Exit
                </button> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommonErrorMessagePopup;
